// removed by extract-text-webpack-plugin
module.exports = {"card-header":"CardHeader__card-header","cardHeader":"CardHeader__card-header"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/CardHeader/CardHeader.css
// module id = 1116
// module chunks = 8